import styled from "@emotion/styled"
import imageLoader from "components/media/imageLoader"
import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"
import { SYNODIC_MONTH } from "./lunar"

const Sprite = styled.span`
  background-image: var(--moon-sprite-background);
  background-position: 0 var(--moon-sprite-y);
  background-repeat: no-repeat;
  background-size: 40px 1200px;
  block-size: var(--moon-sprite-size);
  display: block;
  flex: none;
  inline-size: var(--moon-sprite-size);
  transform: rotate(var(--moon-sprite-rotation));
`

const PHASE_XY = {
  count: 60,
  numx: 12,
  numy: 6,
  padx: 100 / (12 - 1),
  pady: 100 / (6 - 1),
}

// The asset contains 31 chronological frames in a 6 × 6 grid:
// new moon at frame 0, full moon around frame 15, new moon at frame 30.
export default function MoonSprite({ sprite_cal, progress, cell, version = "calendar", hemisphere = "north", size = 50, className }) {
  const console = useConsole()
  const env = useEnv()

  const age = Math.round(cell.phase.age)
  const ppp = Math.floor(cell.phase.illuprog * SYNODIC_MONTH)
  const p = Math.floor(ppp * 30)
  // const y = p * 61

  const normalizedProgress = Number.isFinite(cell.phase.illuprog / 2) ? Math.min(1, Math.max(0, cell.phase.illuprog / 2)) : 0
  const frame = Math.round(normalizedProgress * 30)
  const column = frame % 12
  const row = Math.floor(frame / 5)
  const dimension = typeof size === "number" ? `${size}px` : size

  const pos = Math.floor(PHASE_XY.count * cell.phase.illuprog)
  const x = Math.floor((pos % PHASE_XY.numx) * PHASE_XY.padx)
  const y = Math.floor(pos / PHASE_XY.numy) * PHASE_XY.pady
  // const y = Math.floor((pos / 60) * 50)

  const getUrl = imageLoader({ src: sprite_cal[0] }, env)

  // return `${x}% ${y}%`

  return (
    <Sprite
      aria-hidden='true'
      className={className}
      data-moon-sprite
      style={{
        "--moon-sprite-size": dimension,
        // "--moon-sprite-x": `${x}%`,
        // "--moon-sprite-y": `${y}%`,
        // "--moon-sprite-x": `${column * 10}%`,
        "--moon-sprite-y": `${ppp * -40}px`,

        "--moon-sprite-rotation": hemisphere === "south" ? "180deg" : "0deg",
        "--moon-sprite-background": `url(${getUrl({ width: 80 })})`,
        // "--moon-sprite-background": `url(public/moonphases/spritesheet-5.png`,
      }}
    />
  )
}
